import React from 'react';
import classnames from 'classnames';
import { EditorState, Modifier, Entity, RichUtils, AtomicBlockUtils } from 'draft-js';
import { findLinkEntity, toggleLink } from 'lib/helpers';

export class EditLinkButton extends React.Component {
	render() {
		const { theme, store } = this.props;
		/** @type {Draft.EditorState} */
		const editorState = store.getEditorState();
		const currentBlockType = RichUtils.getCurrentBlockType(editorState);
		const selection = editorState.getSelection();
		const collapsed = selection.isCollapsed();
		const linkEntity = findLinkEntity(editorState);

		const disabled = (
			// 没有有效选区则无法创建链接，光标不在链接上，也无法编辑连接
			collapsed && !linkEntity
			// 代码块里不支持超链接
			|| currentBlockType === 'code-block'
		);
		return (
			<div className={theme.buttonWrapper} onClick={e => e.stopPropagation()} title={linkEntity ? '编辑连接' : '插入超链接'}>
				<button
					ref={button => this.button = button}
					className={classnames(theme.button, {
						[theme.disabled]: disabled,
					})}
					disabled={disabled}
					onClick={() => this.edit(linkEntity)}>
					<i className="qa-ico-link">超</i>
				</button>
			</div>
		);
	}

	edit = (entity) => {
		const url = entity ? entity.getData().url : '';
		const editWidget = this.props.getWidget('link-bar');
		if (editWidget) {
			const button = this.button;
			if (button) {
				this.buttonPosition = Math.floor(button.offsetLeft + button.clientWidth / 2);
			}
			editWidget.getInstance().active(url, this.buttonPosition);
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/linkPlugin/EditLinkButton.jsx